import { BlogPostPreview } from "screens/blog/BlogPostPreview";
import { ResourcesPostPreview } from "@compass/shared/types";

type BlogPreviewType = {
    post: ResourcesPostPreview;
    category?: string;
};

export const BlogPreview = ({ post }: BlogPreviewType) => {
    return (
        <div className="mb-4 break-inside-avoid">
            <BlogPostPreview post={post} />
        </div>
    );
};
